// store/college/student-management/store/_actions.js 
import college from '../../../../utils/API/BackendHelper/admin/college';
import * as types from './_actionTypes';

// Fetch Students Actions
export const fetchStudentsRequest = (params = {}, exportFlag = false) => ({
  type: types.FETCH_STUDENTS_REQUEST,
  payload: params,
  export: exportFlag
});

export const fetchStudentsSuccess = (data) => ({
  type: types.FETCH_STUDENTS_SUCCESS,
  payload: data
});

export const fetchStudentsFailure = (error) => ({
  type: types.FETCH_STUDENTS_FAILURE,
  payload: error
});

// Upload Students Actions
export const uploadStudentsRequest = (data) => ({
  type: types.UPLOAD_STUDENTS_REQUEST,
  payload: data
});

export const uploadStudentsSuccess = (result) => ({
  type: types.UPLOAD_STUDENTS_SUCCESS,
  payload: result
});

export const uploadStudentsFailure = (error) => ({
  type: types.UPLOAD_STUDENTS_FAILURE,
  payload: error
});

// Download Template Actions
export const downloadTemplateRequest = () => ({
  type: types.DOWNLOAD_TEMPLATE_REQUEST
});

export const downloadTemplateSuccess = () => ({
  type: types.DOWNLOAD_TEMPLATE_SUCCESS
});

export const downloadTemplateFailure = (error) => ({
  type: types.DOWNLOAD_TEMPLATE_FAILURE,
  payload: error
});

// Create Student Actions
export const createStudentRequest = (studentData) => ({
  type: types.CREATE_STUDENT_REQUEST,
  payload: studentData
});

export const createStudentSuccess = (student) => ({
  type: types.CREATE_STUDENT_SUCCESS,
  payload: student
});

export const createStudentFailure = (error) => ({
  type: types.CREATE_STUDENT_FAILURE,
  payload: error
});

// Toggle Student Status Actions
export const toggleStudentStatusRequest = (data) => ({
  type: types.TOGGLE_STUDENT_STATUS_REQUEST,
  payload: data
});

export const toggleStudentStatusSuccess = (data) => ({
  type: types.TOGGLE_STUDENT_STATUS_SUCCESS,
  payload: data
});

export const toggleStudentStatusFailure = (error) => ({
  type: types.TOGGLE_STUDENT_STATUS_FAILURE,
  payload: error
});

// Fetch Students Progress Actions
export const fetchStudentsProgressRequest = (params = {}) => ({
  type: types.FETCH_STUDENTS_PROGRESS_REQUEST,
  payload: params
});

export const fetchStudentsProgressSuccess = (data) => ({
  type: types.FETCH_STUDENTS_PROGRESS_SUCCESS,
  payload: data
});

export const fetchStudentsProgressFailure = (error) => ({
  type: types.FETCH_STUDENTS_PROGRESS_FAILURE,
  payload: error
});

// Retry Credentials SMS Actions
export const retryCredentialsSMSRequest = (data) => ({
  type: types.RETRY_CREDENTIALS_SMS_REQUEST,
  payload: data
});

export const retryCredentialsSMSSuccess = (result) => ({
  type: types.RETRY_CREDENTIALS_SMS_SUCCESS,
  payload: result
});

export const retryCredentialsSMSFailure = (error) => ({
  type: types.RETRY_CREDENTIALS_SMS_FAILURE,
  payload: error
});

// Bulk Enroll Actions
export const bulkEnrollRequest = (data) => ({
  type: types.BULK_ENROLL_REQUEST,
  payload: data
});

export const bulkEnrollSuccess = (result) => ({
  type: types.BULK_ENROLL_SUCCESS,
  payload: result
});

export const bulkEnrollFailure = (error) => ({
  type: types.BULK_ENROLL_FAILURE,
  payload: error
});

// Search Students Actions
export const searchStudentsRequest = (data) => ({
  type: types.SEARCH_STUDENTS_REQUEST,
  payload: data
});

export const searchStudentsSuccess = (students) => ({
  type: types.SEARCH_STUDENTS_SUCCESS,
  payload: students
});

export const searchStudentsFailure = (error) => ({
  type: types.SEARCH_STUDENTS_FAILURE,
  payload: error
});

// Get Student by ID Actions
export const getStudentByIdRequest = (studentId) => ({
  type: types.GET_STUDENT_BY_ID_REQUEST,
  payload: { studentId }
});

export const getStudentByIdSuccess = (student) => ({
  type: types.GET_STUDENT_BY_ID_SUCCESS,
  payload: student
});

export const getStudentByIdFailure = (error) => ({
  type: types.GET_STUDENT_BY_ID_FAILURE,
  payload: error
});

// Update Student Actions
export const updateStudentRequest = (studentId, updateData) => ({
  type: types.UPDATE_STUDENT_REQUEST,
  payload: { studentId, updateData }
});

export const updateStudentSuccess = (student) => ({
  type: types.UPDATE_STUDENT_SUCCESS,
  payload: student
});

export const updateStudentFailure = (error) => ({
  type: types.UPDATE_STUDENT_FAILURE,
  payload: error
});

// Delete Student Actions
export const deleteStudentRequest = (studentId) => ({
  type: types.DELETE_STUDENT_REQUEST,
  payload: { studentId }
});

export const deleteStudentSuccess = (studentId) => ({
  type: types.DELETE_STUDENT_SUCCESS,
  payload: studentId
});

export const deleteStudentFailure = (error) => ({
  type: types.DELETE_STUDENT_FAILURE,
  payload: error
});

// Get Students by Course Actions
export const getStudentsByCourseRequest = (courseId, params = {}) => ({
  type: types.GET_STUDENTS_BY_COURSE_REQUEST,
  payload: { courseId, params }
});

export const getStudentsByCourseSuccess = (data) => ({
  type: types.GET_STUDENTS_BY_COURSE_SUCCESS,
  payload: data
});

export const getStudentsByCourseFailure = (error) => ({
  type: types.GET_STUDENTS_BY_COURSE_FAILURE,
  payload: error
});

// Export Students Actions
export const exportStudentsRequest = (params = {}) => ({
  type: types.EXPORT_STUDENTS_REQUEST,
  payload: params
});

export const exportStudentsSuccess = () => ({
  type: types.EXPORT_STUDENTS_SUCCESS
});

export const exportStudentsFailure = (error) => ({
  type: types.EXPORT_STUDENTS_FAILURE,
  payload: error
});

// Dashboard Statistics Actions
export const getDashboardStatsRequest = () => ({
  type: types.GET_DASHBOARD_STATS_REQUEST
});

export const getDashboardStatsSuccess = (stats) => ({
  type: types.GET_DASHBOARD_STATS_SUCCESS,
  payload: stats
});

export const getDashboardStatsFailure = (error) => ({
  type: types.GET_DASHBOARD_STATS_FAILURE,
  payload: error
});

// Legacy Actions (for backward compatibility)
export const blacklistStudentRequest = (studentId) => ({
  type: types.BLACKLIST_STUDENT_REQUEST,
  payload: studentId
});

export const blacklistStudentSuccess = (studentId) => ({
  type: types.BLACKLIST_STUDENT_SUCCESS,
  payload: studentId
});

export const blacklistStudentFailure = (error) => ({
  type: types.BLACKLIST_STUDENT_FAILURE,
  payload: error
});

// UI State Actions
export const setSelectedStudents = (studentIds) => ({
  type: types.SET_SELECTED_STUDENTS,
  payload: studentIds
});

export const clearUploadResult = () => ({
  type: types.CLEAR_UPLOAD_RESULT
});

export const setFilters = (filters) => ({
  type: types.SET_FILTERS,
  payload: filters
});


// Pagination Actions
export const setPage = (page,collegeId=null) => ({
  type: types.SET_PAGE,
  payload: { page, collegeId }
});

export const setPageSize = (pagesize ,collegeId=null) => ({
  type: types.SET_PAGE_SIZE,
  payload: { pagesize, collegeId }
});

export const setSearch = (search,collegeId=null) => ({
  type: types.SET_SEARCH,
  payload: { search, collegeId }
});

export const setStatusFilter = (status,collegeId=null) => ({
  type: types.SET_STATUS_FILTER,
  payload: {status,collegeId}
});

export const setSort = (sortBy, sortOrder) => ({
  type: types.SET_SORT,
  payload: { sortBy, sortOrder }
});

// Fetch Degrees Actions
export const fetchDegreesRequest = (collegeId) => ({
  type: types.FETCH_DEGREES_REQUEST,
  payload: { collegeId }
});

export const fetchDegreesSuccess = (degrees) => ({
  type: types.FETCH_DEGREES_SUCCESS,
  payload: degrees
});

export const fetchDegreesFailure = (error) => ({
  type: types.FETCH_DEGREES_FAILURE,
  payload: error
});

export const fetchAllStudentsWithCurrentFiltersRequest = (collegeId) => ({
  type: types.FETCH_ALL_STUDENTS_WITH_CURRENT_FILTERS_REQUEST,
  payload: { collegeId }
});
export const fetchAllStudentsWithCurrentFiltersSuccess = (students) => ({
  type: types.FETCH_ALL_STUDENTS_WITH_CURRENT_FILTERS_SUCCESS,
  payload: students
});
export const fetchAllStudentsWithCurrentFiltersFailure = (error) => ({
  type: types.FETCH_ALL_STUDENTS_WITH_CURRENT_FILTERS_FAILURE,
  payload: error
});
// Filter Actions
export const setDegreeFilter = (degree, collegeId = null) => ({
  type: types.SET_DEGREE_FILTER,
  payload: { degree, collegeId }
});

export const setBatchFilter = (batch, collegeId = null) => ({
  type: types.SET_BATCH_FILTER,
  payload: { batch, collegeId }
});

export const setSemesterFilter = (semester, collegeId) => ({
  type: types.SET_SEMESTER_FILTER,
  payload: {
    semester,
    collegeId
  }
});
